// What the assistant's cards say about this module, in the four languages:
// `attendance.assistant.clock.*`. The backend sends the key and the English text
// (§16, backend/assistant.js); the card says it in the reader's language. Kept
// apart from index.js because it is a contract with that file: a key changed
// here is changed there.

export default {
  es: {
    clock: {
      field: { modality: 'Trabajando' },
      value: { onSite: 'Presencial', remote: 'En remoto' },
      in: {
        summary: { onSite: 'Ficharte la entrada, presencial', remote: 'Ficharte la entrada, en remoto' },
        action: 'Fichar la entrada',
        after: 'Tu jornada empieza ahora',
        outcome: { onSite: 'Entrada fichada, presencial', remote: 'Entrada fichada, en remoto' },
      },
      out: {
        summary: 'Ficharte la salida y cerrar tu jornada',
        action: 'Fichar la salida',
        after: 'Tu jornada se cierra ahora',
        outcome: 'Salida fichada: tu jornada está cerrada',
      },
    },
  },
  ca: {
    clock: {
      field: { modality: 'Treballant' },
      value: { onSite: 'Presencial', remote: 'En remot' },
      in: {
        summary: { onSite: 'Fitxar-te l’entrada, presencial', remote: 'Fitxar-te l’entrada, en remot' },
        action: 'Fitxar l’entrada',
        after: 'La teva jornada comença ara',
        outcome: { onSite: 'Entrada fitxada, presencial', remote: 'Entrada fitxada, en remot' },
      },
      out: {
        summary: 'Fitxar-te la sortida i tancar la teva jornada',
        action: 'Fitxar la sortida',
        after: 'La teva jornada es tanca ara',
        outcome: 'Sortida fitxada: la teva jornada està tancada',
      },
    },
  },
  en: {
    clock: {
      field: { modality: 'Working' },
      value: { onSite: 'On site', remote: 'Remotely' },
      in: {
        summary: { onSite: 'Clock you in, on site', remote: 'Clock you in, working remotely' },
        action: 'Clock in',
        after: 'Your working day starts now',
        outcome: { onSite: 'Clocked in, on site', remote: 'Clocked in, working remotely' },
      },
      out: {
        summary: 'Clock you out and close your day',
        action: 'Clock out',
        after: 'Your working day closes now',
        outcome: 'Clocked out: your day is closed',
      },
    },
  },
  fr: {
    clock: {
      field: { modality: 'Travail' },
      value: { onSite: 'Sur site', remote: 'À distance' },
      in: {
        summary: { onSite: 'Pointer votre arrivée, sur site', remote: 'Pointer votre arrivée, à distance' },
        action: 'Pointer l’arrivée',
        after: 'Votre journée commence maintenant',
        outcome: { onSite: 'Arrivée pointée, sur site', remote: 'Arrivée pointée, à distance' },
      },
      out: {
        summary: 'Pointer votre départ et clôturer votre journée',
        action: 'Pointer le départ',
        after: 'Votre journée se clôture maintenant',
        outcome: 'Départ pointé : votre journée est clôturée',
      },
    },
  },
}
